import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { Box, Grid } from '@mui/material'
import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { TextField } from 'src/Libs/inputs/formik'
import Select from 'src/Libs/inputs/formik/Select'
import { NdaDownloadButton } from 'src/Libs/nda'
import { CopyToClipboard } from 'src/Elements/CopyToClipboard'
import { getPartnerNumberWithSpaces } from 'src/Libs/service-dashboard/functions'

interface CompanyProfileFormFieldProps {
  companyId: number
  companyName: string
  partnerNumber?: number
}

/**
 * The separated form fields of the company setting update form in CompanyProfileForm.
 *
 * Providing all the fields the company profile form needs in the structure it expects.
 *
 * @constructor
 */
const CompanyProfileFormFields: React.FC<CompanyProfileFormFieldProps> = ({ companyId, companyName, partnerNumber }) => {
  const { t } = useCustomTranslation()
  const { allCountries } = useCountryOptions()

  return (
    <Grid container justifyContent="flex-end" marginBottom={2}>
      <Grid item xs={12} md={6}>
        <Grid container>
          <Grid item xs={12}>
            <TextField label={t('common.street')} name={'address'} required />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label={t('common.zipCode')} name={'zipCode'} required />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label={t('common.location')} name={'place'} required />
          </Grid>
          <Grid item xs={12}>
            <Select label={t('common.country')} name={'country'} options={allCountries} isSearchable required />
          </Grid>
          <Grid item xs={12}>
            <CopyToClipboard
              value={partnerNumber ? getPartnerNumberWithSpaces(partnerNumber) : ''}
              valueToCopy={partnerNumber ? partnerNumber.toString() : ''}
              label={t('common.partner-number')}
              disabled={true}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container>
          <Grid item xs={12}>
            <TextField label={t('common.phone')} name={'phone'} />
          </Grid>
          <Grid item xs={12}>
            <TextField label={t('common.fax')} name={'fax'} />
          </Grid>
          <Grid item xs={12}>
            <TextField disabled label={t('common.vat')} name={'vatNumber'} />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <NdaDownloadButton companyId={companyId} companyName={companyName} withMenu />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CompanyProfileFormFields
